import React from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import CourseButton from "./components/CourseButton";
import useModalHandler from "Utils/useModalHandler";
import CustomEmpty from "components/CustomEmpty";
import SettingModal from "./components/SettingModal";
import { getMyExperimentByEIdList } from "API/navExperiment";
import useRequest from "Utils/useRequest";
import { useParams } from "react-router-dom";
import { ExperimentInfo } from "API/navExperiment";
import ListItem from "../../../ListItem";

interface OrderPlanList {
    dataDetail: ExperimentInfo | null; //当前计划的具体实验项目详情
}

export default function OrderPlanList({ dataDetail }: OrderPlanList) {
    const { experimentId } = useParams<{ experimentId: string }>();
    const [data, { loading }, refreshData] = useRequest(
        () => getMyExperimentByEIdList(experimentId),
        {},
        [experimentId]
    );

    const modal = useModalHandler();

    function onOk() {
        refreshData();
        modal.close();
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    实验计划（{data?.length || 0}）
                </div>

                <CourseButton
                    type="add"
                    onClick={modal.open}
                    className={style.btn}>
                    添加
                </CourseButton>
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <ListItem
                        key={item.id}
                        data={item}
                        refreshData={refreshData}
                    />
                ))}
                {!data?.length && (
                    <CustomEmpty
                        style={{ padding: "100px 0" }}
                        description="暂无数据"
                    />
                )}
            </Spin>

            <SettingModal
                visible={modal.visible}
                onCancel={modal.close}
                onOk={onOk}
                dataDetail={dataDetail}
            />
        </div>
    );
}
